module.exports = __webpack_public_path__ + "img/prioritas.6d1a240c.png";